export default [
  {
    path: '/form-builder',
    name: 'form-builder',
    meta: { authRequired: true, permission: 'formbuilder.list' },
    component: () => import(/* webpackChunkName: "form-builder" */ './Index.vue')
  },
  {
    path: '/form-builder/new',
    name: 'form-builder-new',
    meta: { authRequired: true, permission: 'formbuilder.add' },
    component: () => import(/* webpackChunkName: "form-builder" */ './Builder.vue')
  },
  {
    path: '/form-builder/:id',
    name: 'form-builder-edit',
    meta: { authRequired: true, permission: 'formbuilder.edit' },
    component: () => import(/* webpackChunkName: "form-builder" */ './Builder.vue'),
    props: true
  }
]
